import objectAssign from 'object-assign';
import _ from 'lodash';

import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function dashboardPageReducer(state = initialState.appState, action) {
  let newUsers;
  let newGroupages;
  let newOrders;
  let newPickUpPoints;
  let groupageIndex;
  let newRecipients;

  switch (action.type) {
    case types.CLEAR_FETCHED_ORDER: {
      let fetchedOrder = { expectedPickUpTime: {}};
      return objectAssign({}, state, { fetchedOrder: fetchedOrder});
    }

    case types.ITEM_SAVED:
      return objectAssign({}, state, { tempItems: state.tempItems.concat([action.item])});

    case types.POINTS_FETCHED: {
      let newPoints = JSON.parse(JSON.stringify(state.pickUpPoints));
      _.map(action.points, (point) => {
        newPoints[point.id] = point;
      });
      return objectAssign({}, state, {pickUpPoints: newPoints, loaded: true, gg: 22});
    }

    case types.SET_FILTER_DATE:
      return objectAssign({}, state, { areOrdersLoaded: false, loaded: true });


    case types.ORDERS_HISTORY_FETCHED: {
      let drivers = [];
      _.map(action.ordersForHistory, (order) => {
        if(order.driver) {
          drivers.push(order.driver);
          delete order.driver;
        }

      });
      return objectAssign({}, state, { ordersForHistory: action.ordersForHistory, drivers:  drivers, loaded: true });
    }

    // case types.DRIVER_LOCATION_UPDATED: {
    //   // let locations = objectAssign([], state.driversLocations);
    //   // let locat = locations.find((location) => location.id === action.data.id);
    //   // if(locat)
    //   //   objectAssign(locat, action.data);
    //   // Object.assign(
    //   //   _.find(state.driversLocations.reverse(), {driverId: action.data.driverId}),
    //   // {gpsLocation: action.data.gpsLocation, lat: action.data.gpsLocation.lat, lng: action.data.gpsLocation.lng}
    //   // );
    //   // console.log(state.driversLocations);
    //   return objectAssign({}, state, { driversLocations: state.driversLocations });
    // }

    case types.CARD_UPDATED: {
      let newCards = objectAssign([], state.cards);
      objectAssign(newCards.find((card) => card.default === true), {default: false});
      if(action.users)
        objectAssign(newCards.find((card) => card.id === action.users.id), action.users);
      if(action.card)
        objectAssign(newCards.find((card) => card.id === action.card.id), action.card);

      return objectAssign({}, state, { cards: newCards, loaded: true });
    }

    case types.CITY_FETCHED:
      return objectAssign({}, state, { cityForInfo: action.city, loaded: true });

    case types.IP_FETCHED:
      return objectAssign({}, state, { clientIp: action.ip });

    case types.USER_CREATION_FAILED:
      return objectAssign({}, state, { error: action.error, loaded: true });

    case types.AVATAR_ADDED: { 
      let account = state.account;
      account.avatar = action.user.avatar;
      return objectAssign({}, state, { account: account });
    }
    
    case types.COMPANY_LOGO_ADDED: {
      let company = state.company;
      company.logo = action.company.logo;
      return objectAssign({}, state, { company: company });
    }     

    case types.BILL_UPDATED: {
      let newBills = objectAssign([], state.bills);
      objectAssign(newBills.billings.find((bill) => bill.id === action.response.id), action.response);
      return objectAssign({}, state, { bills: newBills });
    }      

    case types.RESET_CASH_ON_DELIVERY:
      return objectAssign({}, state);

    case types.PURCHASE_SUCCEED:
      return objectAssign({}, state, { fortResponse: action.response });

    case types.GET_NEAREST_DRIVERS:
      return objectAssign({}, state, { nearestDrivers: action.nearestDrivers });

    case types.RESET_NEAREST_DRIVERS:
      return objectAssign({}, state, { nearestDrivers: [] });

    case types.REMOVE_NEAREST_DRIVERS:
      return objectAssign({}, state, { nearestDrivers: [] });

    case types.PURCHASE_NOT_SUCCEED:
      return state;

    case types.ORDERS_ADDED_TO_HISTORY:
      return objectAssign({}, state, { orders: state.orders.concat(action.orders), loaded: true });

    case types.FLEET_CREATED:
      return objectAssign({}, state, { fleets: state.fleets.concat([action.fleet.fleetOwner]), companies: state.companies.concat([action.fleet.company]), loaded: true });

    case types.DRIVER_LIST_VIEW_MODE_CHANGED:
      return objectAssign({}, state, { driverListViewMode: action.driverListViewMode });

    case types.STATISTIC_FETCHED:
      return objectAssign({}, state, { statistics: action.statistic.statistics });

    case types.STATISTIC_FETCH_FAILED:
      return state;

    case types.FLEET_UPDATED: {
      let newFleets = objectAssign([], state.fleets);
      objectAssign(newFleets.find((fleet) => fleet.id === action.fleet.id), action.fleet);
      return objectAssign({}, state, { fleets: newFleets, loaded: true });
    }

    case types.FLEETS_FETCHED:
      return objectAssign({}, state, { fleets: action.fleets });

    case types.ACCOUNT_FETCHED:
      return objectAssign({}, state, { account: action.account, connectionError: false });

    case types.ACCOUNT_FETCHED_FAIL:
      return objectAssign({}, state, { connectionError: true });

    case types.ORDERS_FETCHED:
      return objectAssign({}, state, { orders: action.orders, loaded: true });

    case types.ORDERS_FETCH_FAILED:
      return state;

    case types.ORDERS_COMPANY_FETCHED:
      return objectAssign({}, state, { companyOrders: action.orders, loaded: true });

    case types.ORDERS_COMPANY_FETCH_FAILED:
      return state;

    case types.CARD_ADDED:
      if (action.card.firstPurchase) {
        if (action.card.firstPurchase['3ds_url']) {
          window.location.replace(action.card.firstPurchase['3ds_url']);
        }
      }
      return state;

    case types.CARD_DELETED: {
      let cards = state.cards;
      _.pull(cards, _.find(cards, { id: action.cardId }));
      return objectAssign({}, state, { cards: cards });
    }      

    case types.CARDS_FETCHED:
      return objectAssign({}, state, { cards: action.cards });

    case types.BILLS_FETCHED:
      return objectAssign({}, state, { bills: action.bills });

    case types.SUBSCRIBED:
      return objectAssign({}, state, { subscribed: true });

    case types.ORDER_FOR_RETURN_ADDED:
      return objectAssign({}, state, { orderForReturn: action.order });

    case types.ORDER_FOR_RETURN_REMOVED:
      return objectAssign({}, state, { orderForReturn: {} });

    case types.ORDER_FOR_UPDATE_ADDED:
      return objectAssign({}, state, { orderForUpdate: action.order });

    case types.PICKUP_POINTS_SAVED:
      return objectAssign({}, state, { pickUpPoints: action.pickUpPoints, loaded: true });

    case types.USERS_SAVED:
      return objectAssign({}, state, { users: action.users, loaded: true });

    case types.POINTS_FOR_UPDATE_ADDED:
      return objectAssign({}, state, { pickUpPoints: action.pickUpPoints });

    case types.ORDER_FOR_UPDATE_REMOVED:
      return objectAssign({}, state, { orderForUpdate: {} });

    case types.USER_ADDED_TO_TEAM:
      return objectAssign({}, state, { addedToTeam: Date.now() });

    case types.USER_REMOVED_FROM_TEAM:
      return objectAssign({}, state, { removedFromTeam: Date.now() });

    case types.PICKPOINT_UPDATED:
      newPickUpPoints = objectAssign({}, state.pickUpPoints);
      newPickUpPoints[action.updatedPickUpPoint.id] = action.updatedPickUpPoint;
      return objectAssign({}, state, { pickUpPoints: newPickUpPoints, loaded: true });

    case types.SAVE_PAGE_ORDER_LIST:
      return objectAssign({}, state, { orderListPageNumber: action.orderListPageNumber });

    case types.TEAM_UPDATED:
      return objectAssign({}, state, { teamUpdated: action.team });

    case types.TEAM_DELETED: {
      let teamToDelete = _.find(state.teams, { id: action.teamToDelete });
      let teams = _.pull(state.teams, teamToDelete);
      return objectAssign({}, state, { teams: teams, teamDeleted: Date.now() });
    }

    case types.UNASSIGN_ORDER:
      newOrders = state.orders;
      Object.assign(_.find(newOrders, { id: action.data.status.order.id }), action.data.status.order);
      return objectAssign({}, state, { orders: newOrders, loaded: true });

    case types.SAVE_PAGE_GROUPAGE_LIST:
      return objectAssign({}, state, { groupageListPageNumber: action.groupageListPageNumber });

    case types.SAVE_PAGE_HISTORY_LIST:
      return objectAssign({}, state, { orderHistoryPageNumber: action.orderHistoryPageNumber });

    case types.TIMEOUT_MES:
      function showMessage() {
        if (document.getElementsByClassName('spinnerActive').length > 0) {
          alert("Loading takes more than normally ... Redirecting to Dashboard");
        }
      }
      // setTimeout(showMessage, 15000);
      return state;

    case types.START_SPINNER:
      return objectAssign({}, state, { loaded: action.loaded });

    case types.COMPANY_FETCHED:
      return objectAssign({}, state, { company: action.company });

    case types.TEAMS_FETCHED:
      return objectAssign({}, state, { teams: action.teams });

    case types.END_SPINNER:
      return objectAssign({}, state, { loaded: action.loaded });

    case types.GROUPAGE_CREATED:
      return objectAssign({}, state, { loaded: action.loaded });

    case types.GROUPAGE_DESTROYED:
      return objectAssign({}, state, { loaded: action.loaded });

    case types.ORDER_FETCHED:
      return objectAssign({}, state, { fetchedOrder: action.order });

    case types.ORDER_FETCH_FAILED:
      return objectAssign({}, state, { fetchedOrder: [] });

    case types.PICKUPPOINTS_FETCHED:
      newPickUpPoints = state.pickUpPoints;
      _.map(action.pickUpPoints, (point) => {
        newPickUpPoints[point.id] = point;
      });

      return objectAssign({}, state, {pickUpPoints: newPickUpPoints});
      
    case types.PICKUPPOINT_FETCHED: {
      let points = JSON.parse(JSON.stringify(state.pickUpPoints));
      if(action.pickUpPoint)
        points[action.pickUpPoint.id] = action.pickUpPoint;
      if(action.pickUpPoint[0])
        points[action.pickUpPoint[0].id] = action.pickUpPoint[0];
      return objectAssign({}, state, { pickUpPoints: points});
    }

    case types.GROUPAGES_FETCHED:
      return objectAssign({}, state, { groupages: action.groupages });

    case types.GROUPAGES_FETCH_FAILED:
      return state;

    case types.USERS_FETCHED:
      return objectAssign({}, state, { users: action.users });

    case types.ADMIN_UPDATED:
      return objectAssign({}, state, { account: action.newAdmin });

    case types.ADMIN_UPDATE_FAILED:
      return state;

    case types.COMPANIES_FETCHED:
      return objectAssign({}, state, { companies: action.companies });

    case types.COUNTRY_CREATED:
      return objectAssign({}, state, { countries: action.country });

    case types.COMPANY_WITH_DRIVERS_FETCHED:
      break;

    case types.COUNTRY_UPDATED:
      return state;

    case types.ORDER_UPDATED_LOGGED:
      newOrders = objectAssign([], state.orders);
      objectAssign(_.find(newOrders, { id: action.order.id }), action.order);

      newRecipients = objectAssign([], state.recipients);
      objectAssign(_.find(newRecipients, { id: action.order.recipient.id }), action.order.recipient);

      return objectAssign({}, state, { recipients: newRecipients, orders: newOrders });

    case types.COEFFICIENT_UPDATED:
      return state;

    case types.CITY_UPDATED:
      return state;

    case types.CITY_CREATED:
      return objectAssign({}, state, { cities: action.city });

    case types.CITY_CREATE_FAILED:
      return state;

    case types.COEFFICIENTS_FETCHED:
      return objectAssign({}, state, { coefficients: action.coefficients });

    case types.COEFFICIENTS_FETCH_FAILED:
      return state;

    case types.COMPANY_CREATED:
      return objectAssign({}, state, { companies: state.companies.concat([action.company]), loaded: true });

    case types.COMPANY_DELETED:
      return state;

    case types.COMPANY_UPDATED:
      return objectAssign({}, state, { company: action.company });

    case types.COMPANY_UPDATED_ADMIN: {
      let newCompanies = objectAssign([], state.companies);
      objectAssign(newCompanies.find((company) => company.id === action.company.id), action.company);
      return objectAssign({}, state, { companies: newCompanies, loaded: true });
    }

    case types.CITY_DELETED:
      return state;

    case types.CITY_DELETE_FAILED:
      return state;

    case types.COUNTRY_CREATE_FAILED:
      return state;

    case types.RECIPIENTSORDERS_FETCHED:
      return objectAssign({}, state, { orders: action.users });

    case types.RECIPIENTSORDERS_FETCH_FAILED:
      return state;

    case types.COUNTRY_DELETED:
      return state;

    case types.COUNTRY_DELETE_FAILED:
      return state;

    case types.ORDER_UPDATED_RECIPIENT:
      return state;

    case types.ORDER_UPDATED:
      return state;

    case types.RECIPIENT_UPDATED:
      return state;

    case types.USERS_FETCH_FAILED:
      return state;

    case types.DISPATCHER_FETCHED:
      return objectAssign({}, state, { users: action.account.dispatcher, orders: action.account.order, recipients: action.account.recipient });

    case types.USER_DELETED:
      return objectAssign({}, state, { userDeleted: Date.now() });

    case types.USER_DELETED_FAILED:
      return state;

    case types.ORDER_DELETED_FAILED:
      return state;

    case types.RECIPIENTS_FETCHED:
      return objectAssign({}, state, { recipients: action.recipients, areOrdersLoaded: action.recipients.length>0?true:false });

    case types.RECIPIENT_FETCHED:
      return objectAssign({}, state, { recipients: state.recipients.concat(action.fetched_recipient) });

    case types.COUNTRYES_FETCHED: {
      let countries = action.countries.sort(function(a,b) {
          if ( a.name.en < b.name.en )
              return -1;
          if ( a.name.en > b.name.en )
              return 1;
          return 0;
      } );
      return objectAssign({}, state, { countries: countries });
    }

    case types.COUNTRYES_FETCH_FAILED:
      return state;

    case types.CITYES_FETCHED: {
      let cities = action.cities.sort(function(a,b) {
          if ( a.name.en < b.name.en )
              return -1;
          if ( a.name.en > b.name.en )
              return 1;
          return 0;
      } );
      return objectAssign({}, state, { cities: cities });
    }

    case types.CITYES_FETCH_FAILED:
      return state;

    case types.LOCAL_USER_ADDED:
      if (_.some(state.users, { id: action.user.id })) {
        return state;
      }
      return objectAssign({}, state, { users: state.users.concat([action.user]) });

    case types.LOCAL_USER_UPDATED:
      newUsers = objectAssign([], state.users);
      if (newUsers.find((user) => user.id === action.user.id)) {
        objectAssign(newUsers.find((user) => user.id === action.user.id), action.user);
        return objectAssign({}, state, { users: newUsers, loaded: true });
      }
      else
        return state;


    case types.LOCAL_GROUPAGE_ADDED:
      if (_.some(state.groupages, { id: action.groupage.id })) {
        return state;
      }
      return objectAssign({}, state, { groupages: state.groupages.concat([action.groupage]) });

    case types.LOCAL_GROUPAGE_UPDATED:
      newGroupages = objectAssign([], state.groupages);
      groupageIndex = _.findIndex(newGroupages, { id: action.groupage.id });
      if (action.groupage.groupageStatus === 'rejected') {
        newGroupages.splice(groupageIndex, 1);
      } else {
        objectAssign(newGroupages[groupageIndex], action.groupage);
      }
      return objectAssign({}, state, { groupages: newGroupages });

    case types.LOCAL_ORDER_ADDED:
      if (_.some(state.orders, { id: action.order.id })) {
        newOrders = Object.assign([], state.orders);
        objectAssign(_.find(newOrders, { id: action.order.id }), action.order);
        return objectAssign({}, state, { orders: newOrders });
      }
      if(state.tempItems.length > 0) {
        let newTempItems = state.tempItems;
        action.order.items = _.filter(newTempItems, {orderId: action.order.id});
      }

      return objectAssign({}, state, { orders: state.orders.concat([action.order]) });

    case types.LOCAL_ORDER_UPDATED: {
      newOrders = objectAssign([], state.orders);
      let order = _.find(newOrders, { id: action.order.id });

      if (action.fields && action.fields.autoAssign === 'fail') {
        delete order.driverId;
        delete action.fields.autoAssign;
      }


      if (order){
        if (order.autoAssign === false)
          delete order.autoAssign;
        objectAssign(order, action.order, action.fields);
      }

      /////if ppoint is not exist
      let pointsToFetch = [];

      if(action.fields && action.fields.items)
        _.map(action.fields.items, (item) => {
          if(!state.pickUpPoints[item.pickupPointId])
            pointsToFetch.push(item.pickupPointId);
        });

      return objectAssign({}, state, { orders: newOrders, loaded: true, pointsToFetch: pointsToFetch });
    }

    case types.LOCAL_RECIPIENT_UPDATED:
      newRecipients = objectAssign([], state.recipients);
      objectAssign(_.find(newRecipients, { id: action.recipient.id }), action.recipient, action.fields);
      return objectAssign({}, state, { recipients: newRecipients });

    case types.LOCAL_RECIPIENT_ADDED:
      if (_.some(state.recipients, { id: action.recipient.id })) {
        return state;
      }
      return objectAssign({}, state, { recipients: state.recipients.concat([action.recipient]) });

    case types.LOCAL_PICKUPPOINT_ADDED:
      newPickUpPoints = objectAssign({}, state.pickUpPoints);
      newPickUpPoints[action.pickUpPoint.id] = action.pickUpPoint;
      return objectAssign({}, state, { pickUpPoints: newPickUpPoints });

    case types.LOCAL_PICKUPPOINT_UPDATED:
      newPickUpPoints = objectAssign({}, state.pickUpPoints);
      newPickUpPoints[action.pickUpPoint.id] = action.pickUpPoint;
      return objectAssign({}, state, { pickUpPoints: newPickUpPoints });

    case types.LOCAL_POINT_REMOVED:
      // newPickUpPoints = objectAssign({}, state.pickUpPoints);
      // delete newPickUpPoints[action.pickUpPoint.id];
      // return objectAssign({}, state, { pickUpPoints: newPickUpPoints });
      return state;

    case types.ACCOUNT_UPDATED:
      if(state.account.language !== action.account.language || state.account.dashboardType !== action.account.dashboardType) {
        window.location.replace(document.location.origin);
      }
      return objectAssign({}, state, { account: action.account, accountUpdated: action.accountUpdated });

    // case types.DRIVERS_LOCATION_UPDATED:
    //   return objectAssign({}, state, { driversLocations: action.driversLocations });

    case types.ASSIGN_ON_DRIVER:
      newOrders = objectAssign([], state.orders);
      if(action.order)
      _.map(action.order.status, (order) => {
        objectAssign(_.find(newOrders, { id: order.id }), order);
      });
      return objectAssign({}, state, { orders: newOrders, loaded: action.loaded });

    case types.GET_DRIVERS_COUNT:
      return objectAssign({}, state, { driversCount: action.count });

    case types.SHOW_HEADER_INFO:
      return objectAssign({}, state, { showHeadersInfo: action.show });

    case types.PAY_BILL: {
      const bills = {
        billings: state.bills.billings.map(bill => {
          if (bill.id === action.response.id) {
            bill = action.response;
          }
          return bill;
        })
      };
      return objectAssign({}, state, {
        bills: bills,
        message: {
          message: 'Payment accepted',
          level: 'success'
        }
      });
    }

    case types.CLEAR_MESSAGE:
      return objectAssign({}, state, { message: null });

    case types.PAY_BILL_ERROR:
      return objectAssign({}, state, { error: action.error, loaded: false });

    case types.FETCH_NEW_TOKEN:
      return objectAssign({}, state, { tokens: action.response, loaded: false });

    case types.FETCH_ALL_TIMEZONES:
      return objectAssign({}, state, { timezones: action.response, loaded: true });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js